import { useEffect, useState } from "react";
import api from "@/lib/api";
import AskAurea from "@/components/resources/AskAurea";
import { ExternalLink, Phone, MessageSquare } from "lucide-react";

const SupportSection = ({ category }) => {
  const [data, setData] = useState(null);

  useEffect(() => { api.get(`/support/${category}`).then(({ data }) => setData(data)).catch(() => {}); }, [category]);

  if (!data) return <div className="h-24 rounded-3xl bg-linen-2 animate-pulse" />;

  return (
    <div className="space-y-5" data-testid={`support-${category}`}>
      <p className="text-ink-2 leading-relaxed max-w-3xl">{data.intro}</p>
      <div className="grid sm:grid-cols-2 gap-4">
        {data.items.map((it, i) => (
          <div key={i} className="bg-white rounded-3xl border border-linen-3 p-6 flex flex-col" data-testid={`support-item-${i}`}>
            <div className="flex items-start justify-between gap-2">
              <h3 className="font-serif text-2xl text-ink">{it.name}</h3>
              {it.tag && <span className="text-xs bg-calm text-calm-text px-2.5 py-1 rounded-full shrink-0">{it.tag}</span>}
            </div>
            <p className="text-sm text-ink-2 mt-1 leading-relaxed flex-1">{it.desc}</p>
            <div className="flex flex-wrap items-center gap-x-4 gap-y-1 mt-3 text-sm text-ink-2">
              {it.phone && <span className="flex items-center gap-1.5 text-brand font-medium"><Phone className="w-4 h-4" />{it.phone}</span>}
              {it.text && <span className="flex items-center gap-1.5"><MessageSquare className="w-4 h-4" />{it.text}</span>}
            </div>
            {it.link && (
              <a href={it.link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-sm text-accent hover:underline mt-3 font-medium" data-testid={`support-link-${i}`}>
                Open resource <ExternalLink className="w-3.5 h-3.5" />
              </a>
            )}
          </div>
        ))}
      </div>
      {data.note && <p className="text-sm italic text-brand bg-calm/40 rounded-2xl px-4 py-3">{data.note}</p>}
      <AskAurea topic={data.label} />
    </div>
  );
};

export default SupportSection;
